'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var produce = require('immer');
var reactVirtualized = require('react-virtualized');
var Anser = require('anser');
var escapeCarriage = require('escape-carriage');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var Anser__default = /*#__PURE__*/_interopDefaultLegacy(Anser);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var i18n = {
  'rawLog': 'Raw Log',
  'top': 'Top'
};
function _(token) {
  return i18n.hasOwnProperty(token) ? i18n[token] : token;
}

var Matcher = /*#__PURE__*/_createClass(function Matcher(regexStart, regexEnd, label) {
  var matcherOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _classCallCheck(this, Matcher);

  this.regexStart = void 0;
  this.regexEnd = void 0;
  this.label = void 0;
  this.matcherOptions = void 0;
  this.regexStart = regexStart;
  this.regexEnd = regexEnd;
  this.label = label;
  this.matcherOptions = matcherOptions;
});

var Spliter = /*#__PURE__*/function () {
  function Spliter(matchers) {
    _classCallCheck(this, Spliter);

    this.matchers = void 0;
    this.matchers = matchers;
  }

  _createClass(Spliter, [{
    key: "execute",
    value: function execute(logs) {
      var _this = this;

      return logs.reduce(function (prev, log) {
        return prev.concat(_this.executeLine(log));
      }, []);
    }
  }, {
    key: "executeLine",
    value: function executeLine(log) {
      var lastIndex = 0;
      var particals = [];

      for (var i = 0; i < this.matchers.length; i++) {
        var _this$matchers$i = this.matchers[i],
            regexStart = _this$matchers$i.regexStart,
            regexEnd = _this$matchers$i.regexEnd,
            label = _this$matchers$i.label,
            matcherOptions = _this$matchers$i.matcherOptions;
        regexStart.lastIndex = lastIndex;
        regexEnd.lastIndex = lastIndex;
        var startMatch = regexStart.exec(log);

        if (!startMatch) {
          continue;
        }

        var endMatch = regexEnd.exec(log);

        if (!endMatch) {
          continue;
        }

        var textLabel = label.indexOf('$') === 0 ? startMatch[parseInt(label.replace('$', ''), 10)] : label;
        var startPosition = startMatch.index;
        var endPosition = endMatch.index;
        var cursor = endPosition + endMatch[0].length;

        if (startPosition > lastIndex) {
          particals.push({
            type: 'text',
            content: log.substring(lastIndex, startPosition),
            fold: false
          });
        }

        particals.push({
          label: textLabel,
          type: 'partical',
          content: log.substring(startPosition, cursor),
          fold: !!matcherOptions.defaultFold
        });
        lastIndex = cursor;
      }

      if (lastIndex < log.length) {
        particals.push({
          type: 'text',
          content: log.substring(lastIndex),
          fold: false
        });
      }

      return particals;
    }
  }]);

  return Spliter;
}();
var defaultMatchers = [new Matcher(/travis_fold:start:\w+\n(^.*$)/gm, /travis_fold:end:\w+\n(^.*$)/gm, '$1', {
  defaultFold: true
})];
var defaultSpliters = new Spliter(defaultMatchers);

var defaultErrorMatchers = [{
  desc: 'MissingScript',
  link: 'https://stackoverflow.com/questions/31976722/start-script-missing-error-when-running-npm-start',
  patterns: ['sh: 1: ts-node: not found']
}];
var ErrorMatcher = /*#__PURE__*/function () {
  function ErrorMatcher(errorMatchers) {
    _classCallCheck(this, ErrorMatcher);

    this.patterns = void 0;
    this.patterns = errorMatchers.map(function (matcher) {
      return _objectSpread2(_objectSpread2({}, matcher), {}, {
        regexs: matcher.patterns.map(function (regex) {
          return new RegExp(regex);
        })
      });
    });
  }

  _createClass(ErrorMatcher, [{
    key: "match",
    value: function match(bundle) {
      return this.patterns.map(function (pattern) {
        var errors = pattern.regexs.map(function (regex) {
          return regex.exec(bundle.content);
        }).filter(Boolean);
        return errors.length ? pattern : null;
      }).filter(Boolean);
    }
  }]);

  return ErrorMatcher;
}();

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".log-module_metaList__b3hAq {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.log-module_metaList__b3hAq li {\n  flex: 0 0 50%;\n  margin: 0 0 12px 0;\n}\n.log-module_metaList__b3hAq li em {\n  margin-right: 1em;\n  color: #314659;\n  font-weight: 14px;\n  font-style: normal;\n}\n.log-module_metaList__b3hAq li em::after {\n  content: '\\FF1A';\n}\n.log-module_logMain__3qZ8H {\n  display: block;\n}\n.log-module_hasError__WdVu4 {\n  padding-right: 240px;\n}\n.log-module_logHeader__qu86B {\n  height: 28px;\n  padding: 0.7em 0.8em 0.6em;\n  text-align: right;\n  background: #444;\n}\n.log-module_logBody__1lkPy {\n  position: relative;\n  background-color: #222;\n}\n.log-module_logFooter__z8cj4 {\n  height: 20px;\n  padding: 0 8px;\n  color: #f1f1f1;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: right;\n  background: #222;\n}\n.log-module_backToTop__8GR6Y {\n  padding-right: 12px;\n  color: #f1f1f1;\n  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNSIgd2lkdGg9IjEwIiB2aWV3Qm94PSIwIDAgMTAgNSI+CjxwYXRoIGZpbGw9IiNjMmMyYzIiIGQ9Ik0xMCw1LDUsMCwwLDV6Ii8+Cjwvc3ZnPgo=) right 5px no-repeat #2b2b2b;\n}\n.log-module_foldLine__31P1R,\n.log-module_logLine__3aB2J {\n  position: relative;\n  min-height: 19px;\n  margin: 0;\n  padding: 0 15px 0 62px;\n}\n.log-module_foldLine__31P1R:hover,\n.log-module_logLine__3aB2J:hover,\n.log-module_foldLine__31P1R:hover::before,\n.log-module_logLine__3aB2J:hover::before {\n  background-color: #444 !important;\n}\n.log-module_foldLine__31P1R a.log-module_lineNo__3zxyh,\n.log-module_logLine__3aB2J a.log-module_lineNo__3zxyh {\n  position: absolute;\n  display: inline-block;\n  min-width: 40px;\n  margin-left: calc(-40px - 1em);\n  padding-right: 1em;\n  color: #666;\n  text-align: right;\n  text-decoration: none;\n  cursor: pointer;\n}\n.log-module_error__2UZVu {\n  color: #f97583;\n}\n.log-module_foldLine__31P1R {\n  color: #ffff91;\n  cursor: pointer;\n}\n.log-module_foldLine__31P1R::before {\n  position: absolute;\n  top: 4px;\n  left: 8px;\n  width: 10px;\n  height: 10px;\n  background: url('../media/arrow.svg') 8px 3px no-repeat #2b2b2b;\n  background-position: center;\n  transition: transform cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.3s;\n  content: ' ';\n}\n.log-module_ansi__3IFl- {\n  min-height: 42px;\n  margin-top: 0;\n  margin-bottom: -45px;\n  padding: 15px 0 2em 0;\n  color: #f1f1f1;\n  font-size: 1em;\n  font-family: 'RobotoMono', Monaco, 'Courier New', monospace;\n  line-height: 1.58;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  counter-reset: line-numbering;\n}\n.log-module_fold__2jeTa {\n  position: relative;\n  height: 19px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.log-module_foldOpen__2JSyM {\n  height: auto;\n}\n.log-module_foldOpen__2JSyM .log-module_foldLine__31P1R::before {\n  transform: rotate(90deg);\n}\n";
var styles = {"metaList":"log-module_metaList__b3hAq","logMain":"log-module_logMain__3qZ8H","hasError":"log-module_hasError__WdVu4","logHeader":"log-module_logHeader__qu86B","logBody":"log-module_logBody__1lkPy","logFooter":"log-module_logFooter__z8cj4","backToTop":"log-module_backToTop__8GR6Y","foldLine":"log-module_foldLine__31P1R","logLine":"log-module_logLine__3aB2J","lineNo":"log-module_lineNo__3zxyh","error":"log-module_error__2UZVu","ansi":"log-module_ansi__3IFl-","fold":"log-module_fold__2jeTa","foldOpen":"log-module_foldOpen__2JSyM"};
styleInject(css_248z);

var errorRefs = new Map();
function setErrorRefs(errors, ref) {
  errorRefs.clear();
  errorRefs.set(ref, errors);
}
var ErrorContext = /*#__PURE__*/React.createContext({
  setErrorRefs: setErrorRefs
});

var LINK_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
/**
 * Create a class string.
 * @name createClass
 * @function
 * @param {AnserJsonEntry}.
 * @return {String} class name(s)
 */

function createClass(bundle) {
  var classNames = '';

  if (!bundle.bg && !bundle.fg) {
    return '';
  }

  if (bundle.bg) {
    classNames += bundle.bg + ' ';
  }

  if (bundle.fg) {
    classNames += bundle.fg + ' ';
  }

  classNames = classNames.substring(0, classNames.length - 1);
  return classNames;
}
/**
 * Create the style attribute.
 * @name createStyle
 * @function
 * @param {AnserJsonEntry}.
 * @return {Object} returns the style object
 */


function createStyle(bundle) {
  var style = {};

  if (bundle.bg) {
    style.backgroundColor = "rgb(".concat(bundle.bg, ")");
  }

  if (bundle.fg) {
    style.color = "rgb(".concat(bundle.fg, ")");
  }

  return style;
}

function isEmpty(style) {
  return !style || Object.keys(style).length === 0;
}

function ansiToJSON(input) {
  var useClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  input = escapeCarriage.escapeCarriageReturn(input);
  return Anser__default['default'].ansiToJson(input, {
    json: true,
    remove_empty: true,
    use_classes: useClasses
  });
}

function convertBundleIntoReact(useClasses, linkify, bundle, key) {
  var style = useClasses ? null : createStyle(bundle);
  var className = useClasses ? createClass(bundle) : '';
  var content = bundle.content;

  if (linkify) {
    content = bundle.content.split(/(\s+)/).reduce(function (words, word, index) {
      if (index % 2 === 1) {
        words.push(word);
        return words;
      }

      var matches = LINK_REGEX.exec(word);

      if (!matches) {
        words.push(word);
        return words;
      }

      var matchedUrl = matches[0];
      words.push( /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, word.substring(0, matches.index), /*#__PURE__*/React__default['default'].createElement("a", {
        key: index,
        href: matchedUrl,
        target: "_blank",
        rel: "noopener noreferer"
      }, matchedUrl), word.substring(matches.index + matchedUrl.length)));
      return words;
    }, []);
  }

  if (!isEmpty(style) || className) {
    return /*#__PURE__*/React__default['default'].createElement("span", {
      style: style || {},
      key: key
    }, content);
  }

  return content;
}

function RawLogger(_ref) {
  var partical = _ref.partical,
      errorMatcher = _ref.errorMatcher,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$foldable = _ref.foldable,
      foldable = _ref$foldable === void 0 ? false : _ref$foldable,
      _ref$useClasses = _ref.useClasses,
      useClasses = _ref$useClasses === void 0 ? false : _ref$useClasses,
      _ref$linkify = _ref.linkify,
      linkify = _ref$linkify === void 0 ? false : _ref$linkify,
      forwardRef = _ref.forwardRef,
      style = _ref.style;

  var _useContext = React.useContext(ErrorContext),
      setErrorRefs = _useContext.setErrorRefs;

  var lineProps = {
    useClasses: useClasses,
    linkify: linkify,
    errorMatcher: errorMatcher
  };

  var _useState = React.useState(partical.fold),
      _useState2 = _slicedToArray(_useState, 2),
      fold = _useState2[0],
      setFold = _useState2[1];

  var line = React__default['default'].useMemo(function () {
    return ansiToJSON(partical.content).reduce(function (prev, bundle, index) {
      var content = convertBundleIntoReact(useClasses, linkify, bundle, index);
      var errors = errorMatcher.match(bundle);
      return {
        content: prev.content.concat([content]),
        errors: prev.errors.concat(errors)
      };
    }, {
      content: [],
      errors: []
    });
  }, [partical, styles, useClasses, linkify, errorMatcher]);

  if (foldable) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: fold ? styles.fold : styles.foldOpen,
      ref: forwardRef,
      style: style
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      key: "folder-placeholder-".concat(index),
      className: styles.foldLine,
      onClick: function onClick() {
        return setFold(!fold);
      }
    }, partical.label ? ansiToJSON(partical.label).map(convertBundleIntoReact.bind(null, useClasses, linkify)) : null), /*#__PURE__*/React__default['default'].createElement(Line, _objectSpread2(_objectSpread2({}, lineProps), {}, {
      line: line.content,
      errors: line.errors,
      index: index,
      saveRef: setErrorRefs
    })));
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    ref: forwardRef,
    style: style,
    key: "line-".concat(index)
  }, /*#__PURE__*/React__default['default'].createElement(Line, _objectSpread2(_objectSpread2({}, lineProps), {}, {
    line: line.content,
    errors: line.errors,
    index: index,
    saveRef: setErrorRefs
  })));
}
function Line(_ref2) {
  var line = _ref2.line,
      errors = _ref2.errors,
      index = _ref2.index,
      saveRef = _ref2.saveRef;
  var ref = /*#__PURE__*/React__default['default'].createRef();
  React.useEffect(function () {
    if (errors.length && ref.current && saveRef) {
      saveRef(errors, ref.current);
    }
  }, [ref.current, errors]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(styles.logLine, " ").concat(errors.length ? styles.error : ''),
    key: index,
    ref: ref
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: styles.lineNo,
    key: "lineNo-".concat(index)
  }, index), line);
}
var RawLogger$1 = /*#__PURE__*/React__default['default'].forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default['default'].createElement(RawLogger, _objectSpread2(_objectSpread2({}, props), {}, {
    forwardRef: ref
  }));
});

var measurementCache = new reactVirtualized.CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 25
});
function VirtualLogContent(_ref) {
  var particals = _ref.particals,
      style = _ref.style,
      linkify = _ref.linkify,
      errorMatcher = _ref.errorMatcher,
      autoScroll = _ref.autoScroll;
  var rowRenderer = React.useCallback(function (_ref2) {
    var key = _ref2.key,
        index = _ref2.index,
        style = _ref2.style,
        parent = _ref2.parent;
    var partical = particals[index];
    return /*#__PURE__*/React__default['default'].createElement(reactVirtualized.CellMeasurer, {
      cache: measurementCache,
      columnIndex: 0,
      rowIndex: index,
      key: key,
      parent: parent
    }, /*#__PURE__*/React__default['default'].createElement(RawLogger$1, {
      partical: partical,
      key: "logger-line-".concat(index),
      foldable: partical.type === 'partical',
      index: index,
      linkify: linkify,
      errorMatcher: errorMatcher,
      style: style
    }));
  }, [particals, linkify, errorMatcher]);
  return /*#__PURE__*/React__default['default'].createElement("pre", {
    id: "log",
    className: styles.ansi,
    style: style
  }, /*#__PURE__*/React__default['default'].createElement(reactVirtualized.AutoSizer, null, function (_ref3) {
    var width = _ref3.width,
        height = _ref3.height;
    return /*#__PURE__*/React__default['default'].createElement(reactVirtualized.List, {
      rowCount: particals.length,
      rowRenderer: rowRenderer,
      width: width,
      height: height,
      deferredMeasurementCache: measurementCache,
      rowHeight: measurementCache.rowHeight,
      overscanRowCount: 10,
      scrollToAlignment: autoScroll ? 'end' : 'auto'
    });
  }));
}
function ClassicLogContent(_ref4) {
  var particals = _ref4.particals,
      style = _ref4.style,
      linkify = _ref4.linkify,
      errorMatcher = _ref4.errorMatcher;
  return /*#__PURE__*/React__default['default'].createElement("pre", {
    id: "log",
    className: styles.ansi,
    style: style
  }, particals.map(function (partical, index) {
    return /*#__PURE__*/React__default['default'].createElement(RawLogger$1, {
      key: "logger-line-".concat(index),
      foldable: partical.type === 'partical',
      partical: partical,
      index: index,
      linkify: linkify,
      errorMatcher: errorMatcher
    });
  }));
}
function LogContent(props) {
  if (props.virtual) {
    return /*#__PURE__*/React__default['default'].createElement(VirtualLogContent, _objectSpread2({}, props));
  }

  return /*#__PURE__*/React__default['default'].createElement(ClassicLogContent, _objectSpread2({}, props));
}

produce.enableMapSet();
var MemorizedLogContent = /*#__PURE__*/React__default['default'].memo(LogContent);
function FoldableLogger(_ref) {
  var style = _ref.style,
      bodyStyle = _ref.bodyStyle,
      _ref$logStyle = _ref.logStyle,
      logStyle = _ref$logStyle === void 0 ? {} : _ref$logStyle,
      log = _ref.log,
      children = _ref.children,
      _ref$matchers = _ref.matchers,
      matchers = _ref$matchers === void 0 ? defaultMatchers : _ref$matchers,
      _ref$errorMatchers = _ref.errorMatchers,
      errorMatchers = _ref$errorMatchers === void 0 ? defaultErrorMatchers : _ref$errorMatchers,
      _ref$autoScroll = _ref.autoScroll,
      autoScroll = _ref$autoScroll === void 0 ? false : _ref$autoScroll,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? false : _ref$showHeader,
      _ref$linkify = _ref.linkify,
      linkify = _ref$linkify === void 0 ? true : _ref$linkify,
      _ref$virtual = _ref.virtual,
      virtual = _ref$virtual === void 0 ? false : _ref$virtual;

  var _useState = React.useState(autoScroll),
      _useState2 = _slicedToArray(_useState, 2),
      autoScrollFlag = _useState2[0],
      setAutoScrollFlag = _useState2[1];

  var bodyRef = React.useRef(null);
  var spliter = React__default['default'].useMemo(function () {
    return new Spliter(matchers);
  }, [matchers]);
  var errorMatcher = React__default['default'].useMemo(function () {
    return new ErrorMatcher(errorMatchers);
  }, [errorMatchers]);

  var _useState3 = React.useState(new Map()),
      _useState4 = _slicedToArray(_useState3, 2),
      errors = _useState4[0],
      setErrors = _useState4[1];

  var logArray = React.useMemo(function () {
    return Array.isArray(log) ? log : log.split(/\r?\n/);
  }, [log]);
  var setErrorRefs = React.useCallback(function (error, ref) {
    setErrors(function (err) {
      return produce__default['default'](err, function (draft) {
        draft.set(ref, error);
      });
    });
  }, [setErrors]);
  var foldedLogger = React__default['default'].useMemo(function () {
    return spliter.execute(logArray);
  }, [spliter, log]);
  React.useEffect(function () {
    if (autoScrollFlag && bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [log, matchers, bodyRef.current]); // Event listener: if user scrolling log content, then pause auto scroll
  // resume: scroll to bottom

  var pauseOrResumeScrolling = React__default['default'].useCallback(function () {
    if (!bodyRef.current) {
      return;
    }

    var _bodyRef$current = bodyRef.current,
        scrollHeight = _bodyRef$current.scrollHeight,
        scrollTop = _bodyRef$current.scrollTop,
        offsetHeight = _bodyRef$current.offsetHeight;
    setAutoScrollFlag(scrollHeight - (scrollTop + offsetHeight) < 50);
  }, [bodyRef.current]);
  React.useEffect(function () {
    if (bodyRef.current) {
      bodyRef.current.addEventListener('scroll', pauseOrResumeScrolling);
    }

    return function () {
      bodyRef.current && bodyRef.current.removeEventListener('scroll', pauseOrResumeScrolling);
    };
  }, [bodyRef.current, pauseOrResumeScrolling]);

  function scrollBodyToTop() {
    if (!bodyRef.current) {
      return;
    }

    bodyRef.current.scrollTop = 0;
  }

  return /*#__PURE__*/React__default['default'].createElement(ErrorContext.Provider, {
    value: {
      setErrorRefs: setErrorRefs
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(styles.logMain, " ").concat(errors.size ? styles.hasError : ''),
    style: style
  }, showHeader ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.logHeader
  }, /*#__PURE__*/React__default['default'].createElement("button", null, _('rawLog'))) : null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.logBody,
    style: bodyStyle,
    ref: bodyRef
  }, /*#__PURE__*/React__default['default'].createElement(MemorizedLogContent, {
    particals: foldedLogger,
    style: logStyle,
    linkify: linkify,
    errorMatcher: errorMatcher,
    virtual: virtual,
    autoScroll: autoScrollFlag
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.logFooter,
    onClick: scrollBodyToTop
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: styles.backToTop
  }, _('top')))), errors.size && children ? children({
    hasError: !!errors.size,
    errors: errors
  }) : null);
}

exports.ErrorContext = ErrorContext;
exports.Matcher = Matcher;
exports.default = FoldableLogger;
exports.errorRefs = errorRefs;
